import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './styles/responsive.css';
import { captureGclidFromUrl } from './hooks/useCaptureGclid';

// Registriert die CCM19-Listener: Meta-Pixel und Matomo starten erst nach Einwilligung.
import './lib/trackerConsent';

// Import UI5 Web Components base configuration
import '@ui5/webcomponents/dist/Assets.js';
import '@ui5/webcomponents-fiori/dist/Assets.js';

// Set UI5 global language to German — affects DatePicker format, number formats, etc.
import { setLanguage } from '@ui5/webcomponents-base/dist/config/Language.js';
setLanguage('de');

// Capture Google Ads click ID BEFORE React mounts — router redirects would
// otherwise strip the ?gclid=... query param before we can read it.
captureGclidFromUrl();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
